import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/Checkin_isotipo_White.svg'
import _imports_1 from '@/assets/qr_code.svg'
import _imports_2 from '@/assets/form_registration.svg'
import _imports_3 from '@/assets/groups.svg'
import _imports_4 from '@/assets/checking.svg'
import _imports_5 from '@/assets/checkin-pcmobile.png'


const _hoisted_1 = { class: "introduction-container" }
const _hoisted_2 = {
  key: 0,
  class: "flex-desktop"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("figure", { class: "page_onboarding-logo" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "flex-desktop"
}
const _hoisted_6 = {
  class: "flex-desktop",
  style: {"position":"absolute","top":"23px","right":"40px"}
}
const _hoisted_7 = { style: {"width":"50vw"} }
const _hoisted_8 = {
  class: "flex-desktop",
  style: {"color":"white"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("figure", {
  class: "page_onboarding-logo",
  style: {"margin-right":"40px"}
}, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_10 = { style: {"width":"550px","margin":"0 auto"} }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "introduction-title" }, [
  /*#__PURE__*/_createTextVNode(" Guest management "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("made easy ")
], -1)
const _hoisted_12 = { style: {"width":"260px"} }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { style: {"color":"#7165e3","font-weight":"bold"} }, " GET STARTED ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "description-list",
  style: {"margin-top":"40px"}
}, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
    /*#__PURE__*/_createElementVNode("div", null, "Create, send and scan QR codes")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }),
    /*#__PURE__*/_createElementVNode("div", null, "Easily build your event registration form")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }),
    /*#__PURE__*/_createElementVNode("div", null, "Import guest mailing lists")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }),
    /*#__PURE__*/_createElementVNode("div", null, "Get full attendance control")
  ])
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"50vw","text-align":"right"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "pcmobile",
    src: _imports_5
  }),
  /*#__PURE__*/_createTextVNode("; "),
  /*#__PURE__*/_createElementVNode("div", {
    class: "flex-desktop",
    style: {"position":"absolute","bottom":"20px","left":"calc(75vw - 155px)"}
  }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://apps.apple.com/us/app/check-in-by-beamian/id6444030004?itsct=apps_box_badge&itscg=30200",
        style: {"display":"inline-block","overflow":"hidden","border-radius":"13px","width":"187px","height":"62px","margin-top":"12px"}
      }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: "https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&releaseDate=1672704000",
          alt: "Download on the App Store",
          style: {"border-radius":"13px","width":"187px","height":"62px"}
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://play.google.com/store/apps/details?id=com.beamian.check&pcampaignid=web_share&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1" }, [
        /*#__PURE__*/_createElementVNode("img", {
          alt: "Get it on Google Play",
          src: "https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png",
          style: {"width":"225px"}
        })
      ])
    ])
  ])
], -1)
const _hoisted_16 = { class: "container" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h1", { class: "text-white" }, "Guest management made easy", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "text-white" }, [
  /*#__PURE__*/_createTextVNode(" Import guest lists or easily build your event registration form. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Create, send and scan QR codes. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Get full attendance control. ")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_20 = { class: "ion-text-center text-white" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("b", null, "here", -1)

import { createOutline } from "ionicons/icons";
import {
  IonButton,
  IonIcon,
  IonPage,
  IonContent,
  IonFooter,
  useIonRouter,
} from "@ionic/vue";
import { useUserStore } from "@/stores/user";
import { useWindowWidth } from "@/composition/window";


export default /*#__PURE__*/_defineComponent({
  __name: 'Introduction',
  setup(__props) {

const { isMobile } = useWindowWidth();
const router = useIonRouter();

const navigate = (endpoint: string) => {
  window.location.href = endpoint;
};

const next = () => {
  const userStore = useUserStore();
  if (userStore.userIsLoggedIn) {
    router.push("/onboarding/new-event");
  } else {
    router.push("/onboarding/new-account");
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_unref(IonPage), { class: "page_onboarding-introduction" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_unref(isMobile))
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
              : _createCommentVNode("", true),
            (!_unref(isMobile))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_unref(IonButton), {
                      color: "primary",
                      style: {"margin-right":"20px"},
                      expand: "block",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (navigate('/login'))),
                      fill: "outline",
                      class: "ion-margin-bottom"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" LOG IN ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonButton), {
                      color: "primary",
                      expand: "block",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (next())),
                      class: "ion-margin-bottom"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" SIGN UP ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("div", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (navigate('https://beamian.com/lp-about-beamian'))),
                        style: {"margin-right":"60px","margin-top":"40px","cursor":"pointer"}
                      }, " About us "),
                      _createElementVNode("div", {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (
                  navigate('https://info.beamian.com/need-more-than-check-in')
                )),
                        style: {"margin-top":"40px","cursor":"pointer"}
                      }, " Need more? ")
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_unref(IonButton), {
                          color: "light",
                          expand: "block",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (next())),
                          class: "ion-margin-top"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_13
                          ]),
                          _: 1
                        })
                      ]),
                      _hoisted_14
                    ])
                  ]),
                  _hoisted_15
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      (_unref(isMobile))
        ? (_openBlock(), _createBlock(_unref(IonFooter), { key: 0 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("section", null, [
                  _hoisted_17,
                  _hoisted_18,
                  _hoisted_19,
                  _createVNode(_unref(IonButton), {
                    color: "primary",
                    expand: "block",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (next())),
                    class: "ion-margin-bottom"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        slot: "start",
                        icon: _unref(createOutline)
                      }, null, 8, ["icon"]),
                      _createTextVNode(" Start ")
                    ]),
                    _: 1
                  }),
                  _createElementVNode("p", _hoisted_20, [
                    _createTextVNode(" If you have an account you can login "),
                    _createVNode(_component_router_link, { to: "/login" }, {
                      default: _withCtx(() => [
                        _hoisted_21
                      ]),
                      _: 1
                    }),
                    _createTextVNode(". ")
                  ])
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})